<template>
  <div>
    <div class="tw-bg-white tw-shadow tw-border-t tw-border-gray-200">
      <base-content class="tw-pb-0 tw-pt-0 tw-mt-2 tw-flex tw-justify-between">
        <base-tabs class="tw-pb-4 md:tw-pb-0 tw-mb-0" no-border @click="tabClick($event)">
          <base-tab v-for="tab in tabs" :key="tab.title" :selected="currentComponent === tab.component" :title="tab.title" />
        </base-tabs>
        <base-button v-show="!isLocationFiltered" @click="add" class="tw-hidden sm:tw-flex" size="sm" type="text">
          <template v-slot:icon>
            <plus-icon />
          </template>
          New Activity
        </base-button>
        <base-icon @click="add" class="tw-inline sm:tw-hidden">
          <plus-icon class="tw-h-5 tw-w-5" />
        </base-icon>
      </base-content>
    </div>
    <base-content>
      <component
        :is="currentComponent"
        :business-id="businessId"
        :query="query"
        :targetEntityId="userId"
        @approve="approve"
        @deny="deny"
        @assign="assign"
        @assign-location="assignLocation"
        @comment="comment"
        @del="del"
        @history="history"
      />
    </base-content>
    <NewTodoItem ref="newTodoModal" :businessId="businessId" :userId="userId" />
    <assign-todo-item ref="assignModal" :businessId="businessId" />
    <assign-location ref="assignLocationModal" :businessId="businessId" />
    <delete-todo-item ref="deleteModal" :businessId="businessId" />
    <addNote ref="addNoteModal" :businessId="businessId" />
    <view-details ref="historyModal" :businessId="businessId" />
    <deny-rx-auth ref="denyModal" :businessId="businessId" />
    <approve-rx-auth ref="approveModal" :businessId="businessId" />
  </div>
</template>

<script>
import NewTodoItem from "@/views/business/todo/components/NewTodoItem";
import ViewDetails from "@/views/business/todo/components/ViewDetails";
import AddNote from "@/views/business/todo/components/AddNote";
import AssignTodoItem from "@/views/business/todo/components/AssignTodoItem";
import AssignLocation from "@/views/business/todo/components/AssignLocation";
import DeleteTodoItem from "@/views/business/todo/components/DeleteTodoItem";
import ApproveRxAuth from "@/views/business/todo/components/ApproveRxAuth";
import DenyRxAuth from "@/views/business/todo/components/DenyRxAuth";
import { PlusIcon, SearchIcon } from "@/assets/svgs";
import { mapGetters } from "vuex";

export default {
  name: "BusinessMemberTodoView",
  props: {
    businessId: String,
    userId: String,
  },
  components: {
    NewTodoItem,
    AssignTodoItem,
    DeleteTodoItem,
    PlusIcon,
    SearchIcon,
    AddNote,
    ViewDetails,
    ApproveRxAuth,
    DenyRxAuth,
    AssignLocation,
    UnassignedTodoView: () => import("@/views/business/todo/business-todo/UnassignedTodoView"),
    AssignedTodoView: () => import("@/views/business/todo/business-todo/AssignedTodoView"),
    CompletedTodoView: () => import("@/views/business/todo/business-todo/CompletedTodoView"),
    DeletedTodoView: () => import("@/views/business/todo/business-todo/DeletedTodoView"),
  },
  data() {
    return {
      query: null,
      currentComponent: this.isLocationFiltered === true ? "AssignedTodoView" : "UnassignedTodoView",
    };
  },
  computed: {
    ...mapGetters("role", { isLocationFiltered: "isLocationFiltered" }),
    tabs() {
      let tabItems = [];

      if (this.isLocationFiltered === false) tabItems.push({ title: "Unassigned", component: "UnassignedTodoView", route: "unassigned" });

      tabItems.push(
        { title: "Assigned", component: "AssignedTodoView", route: "assigned" },
        { title: "Completed", component: "CompletedTodoView", route: "completed" },
        { title: "Deleted", component: "DeletedTodoView", route: "deleted" },
      );

      return tabItems;
    },
  },
  mounted() {
    this.currentComponent = this.isLocationFiltered === true ? "AssignedTodoView" : "UnassignedTodoView";
  },
  methods: {
    assign(item) {
      this.$refs.assignModal.show(item);
    },
    assignLocation(item) {
      this.$refs.assignLocationModal.show(item);
    },
    complete(item) {
      this.$refs.completeModal.show(item);
    },
    approve(item) {
      this.$refs.approveModal.show(item);
    },
    deny(item) {
      this.$refs.denyModal.show(item);
    },
    comment(item) {
      this.$refs.addNoteModal.show(item.todoItemId, item.constant);
    },
    history(item) {
      this.$refs.historyModal.show(item);
    },
    del(item) {
      this.$refs.deleteModal.show(item);
    },
    tabClick(tabTitle) {
      const tab = this.tabs.find((t) => t.title === tabTitle);

      if (this.currentComponent !== tab.component) this.currentComponent = tab.component;
    },
    href(path) {
      if (this.$route.path !== path) {
        this.$router.push({
          path,
          params: { businessId: this.businessId },
        });
      }
    },
    add() {
      this.$refs.newTodoModal.show();
    },
    handleUpdate() {
      this.EventBus.$emit("activitiesUpdated", {});
    },
  },
};
</script>
